/**
 * デフォルト表示日(?dateパラメータ無しで開いた場合の日付)をJST基準で計算する。
 * JST午前7時を境に「前日」「前々日」を切り替える(業者側の定期スクレイピングが
 * JST 07:00/18:00で走ることに合わせたユーザー指示による仕様)。日曜は市場が休みで
 * 前日(土曜)にデータが無いため、時刻に関わらず常に前々日(=前週金曜)を採用する。
 * 公開サイト(client.ts)の日付ページャと管理画面TOP(adminIndexClient.ts)の両方で使う。
 */
export function computeDefaultTargetDate(now: Date): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hourCycle: "h23",
  }).formatToParts(now);
  const get = (type: string) =>
    Number(parts.find((p) => p.type === type)?.value);
  const todayUtcMs = Date.UTC(get("year"), get("month") - 1, get("day"));
  const isSunday = new Date(todayUtcMs).getUTCDay() === 0;
  const daysBack = isSunday || get("hour") < 7 ? 2 : 1;
  const targetMs = todayUtcMs - daysBack * 24 * 60 * 60 * 1000;
  return new Date(targetMs).toISOString().slice(0, 10);
}

/** targetDate以前で最も新しい日付のインデックスを返す(該当が無ければ最新日付) */
export function pickDefaultIndex(dates: string[], targetDate: string): number {
  let index = -1;
  for (let i = 0; i < dates.length; i++) {
    if ((dates[i] as string) <= targetDate) index = i;
    else break;
  }
  return index >= 0 ? index : dates.length - 1;
}
